/**
 * Branding-compatible localStorage helpers (Phase 2B).
 *
 * Все обращения к localStorage за пользовательскими настройками SPA должны
 * идти через `lsGet` / `lsSet` / `lsRemove`. Это позволяет постепенно
 * мигрировать ключи с префикса `consolida.` → `collegium.` без потери
 * настроек у активных пользователей.
 *
 * Стратегия:
 *   - read: пробуем новое имя (`collegium.X`), fallback на старое (`consolida.X`).
 *   - write: пишем оба ключа одновременно (dual-write).
 *   - remove: удаляем оба.
 *
 * После Phase 2F (когда все клиенты обновлены) — удалим запись/чтение
 * старого префикса.
 */

const NEW_PREFIX = "collegium.";
const LEGACY_PREFIX = "consolida.";

function safeLS(): Storage | null {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function lsGet(key: string): string | null {
  const ls = safeLS();
  if (!ls) return null;
  try {
    const newVal = ls.getItem(NEW_PREFIX + key);
    if (newVal !== null) return newVal;
    return ls.getItem(LEGACY_PREFIX + key);
  } catch {
    return null;
  }
}

export function lsSet(key: string, value: string): void {
  const ls = safeLS();
  if (!ls) return;
  try {
    ls.setItem(NEW_PREFIX + key, value);
    ls.setItem(LEGACY_PREFIX + key, value);
  } catch {
    /* quota exceeded or storage disabled — silently ignore */
  }
}

export function lsRemove(key: string): void {
  const ls = safeLS();
  if (!ls) return;
  try {
    ls.removeItem(NEW_PREFIX + key);
    ls.removeItem(LEGACY_PREFIX + key);
  } catch {
    /* ignore */
  }
}
